import { CalendarRange } from 'src/components/Schedule/common/context/CalendarContext.interface';
import { Time } from 'src/components/Schedule/common/interfaces/ScheduleTime.interface';

export const TIME_REGEX = /^([01]?\d|2[0-3]):([0-5]?\d):([0-5]\d)$/;

export default class DateTimeUtils {
    static getTime(date: Date): string {
        //HH:MM
        return `${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
    }

    static getTimeWithSeconds(date: Date): string {
        //HH:MM:SS
        return (
            `${date.getHours().toString().padStart(2, '0')}:` +
            `${date.getMinutes().toString().padStart(2, '0')}:` +
            `${date.getSeconds().toString().padStart(2, '0')}`
        );
    }

    static addMinutesAndFormat(date: Date, minutesToAdd: number): string {
        //HH:MM:SS
        const minutesToMiliseconds = 60000;
        const updatedDate = new Date(date.getTime() + minutesToAdd * minutesToMiliseconds);
        return DateTimeUtils.getTimeWithSeconds(updatedDate);
    }

    static getFullDate(date: string | Date, time: Time): Date {
        const { hour, minute, second, nano } = time;

        const milliseconds = Math.floor(nano / 1_000_000);
        const constructedDate = new Date(date);

        constructedDate.setHours(hour);
        constructedDate.setMinutes(minute);
        constructedDate.setSeconds(second);
        constructedDate.setMilliseconds(milliseconds);

        return constructedDate;
    }

    static getFormattedDate = (date: Date): string => {
        // YYYY-MM-DD
        return new Intl.DateTimeFormat('en-CA', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        }).format(date);
    };

    static convertTimeToDate(time: string, date?: Date) {
        if (!TIME_REGEX.test(time)) {
            throw new Error("Invalid time format. Expected 'HH:MM:SS'.");
        }

        const [hour, minute, second] = time.split(':').map(Number);

        return DateTimeUtils.getFullDate(date ?? new Date(), { hour, minute, second, nano: 0 });
    }

    /**
     * @deprecated
     * react big calendar does not provide a way to get inital week range.
     * If things change in the future, this method should be removed
     */
    static getWeekRange(today: Date): CalendarRange {
        const day = today.getDay();
        const isoDay = day === 0 ? 7 : day;

        const firstWeekDay = new Date(today);
        firstWeekDay.setDate(today.getDate() - isoDay + 1);

        const lastWeekDay = new Date(firstWeekDay);
        lastWeekDay.setDate(firstWeekDay.getDate() + 6);

        return { start: firstWeekDay, end: lastWeekDay };
    }
}
